import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function subjectTypeLabel(type) {
  if (!type) return "—";
  const parts = type.split("\\");
  return parts[parts.length - 1] || type;
}

export default function ActivityLogDetailModal({ show, onHide, log }) {
  const { t } = useTranslation();
  if (!log) return null;

  const causerName = log.causer
    ? log.causer.name || log.causer.email || `#${log.causer_id}`
    : `#${log.causer_id}`;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {t("Activity Log")} #{log.id}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <dl className="row mb-0">
          <dt className="col-sm-3">{t("Description")}</dt>
          <dd className="col-sm-9">{log.description || "—"}</dd>

          <dt className="col-sm-3">{t("Causer")}</dt>
          <dd className="col-sm-9">{causerName}</dd>

          <dt className="col-sm-3">{t("Subject Type")}</dt>
          <dd className="col-sm-9">{subjectTypeLabel(log.subject_type)}</dd>

          <dt className="col-sm-3">{t("Subject ID")}</dt>
          <dd className="col-sm-9">{log.subject_id ?? "—"}</dd>

          <dt className="col-sm-3">{t("Created At")}</dt>
          <dd className="col-sm-9">
            {log.created_at ? new Date(log.created_at).toLocaleString() : "—"}
          </dd>

          {log.properties && Object.keys(log.properties).length > 0 && (
            <>
              <dt className="col-sm-3">{t("Properties")}</dt>
              <dd className="col-sm-9">
                <pre className="bg-white p-2 rounded small mb-0">
                  {JSON.stringify(log.properties, null, 2)}
                </pre>
              </dd>
            </>
          )}
        </dl>
      </Modal.Body>
    </Modal>
  );
}
